   <template>
   	<div id="previewTools">

   <div id="previewbar" class="bg-dark">
        <nav class="navbar navbar-light bg-dark flex justify-center">
          <form class="btn-group mx-auto">
            <!-- <button class="btn btn-outline-light" v-bind:class="[tabletActive ? 'active' : '']" @click="viewport('tablet')" type="button">Tablet</button> -->
            <button class="btn btn-outline-light" v-bind:class="[mobileActive ? 'active' : '']" @click="viewport('mobile')" type="button">Mobile</button>
            <!-- <button class="btn btn-outline-light" v-bind:class="[desktopActive ? 'active' : '']" @click="viewport('desktop')" type="button">Desktop</button> -->
            <button class="btn btn-outline-light" v-bind:class="[noneActive ? 'active' : '']" @click="viewport('none')" type="button">Desktop</button> 
          </form>
        </nav>
    </div>

<!--
    	<button class="btn btn-outline-light rounded-circle phone shadow" v-bind:class="[mobileActive ? 'active' : '']" @click="viewport('mobile')" type="button">Mobile</button>
   		<button class="btn btn-outline-light rounded-circle desktop shadow" v-bind:class="[noneActive ? 'active' : '']" @click="viewport('none')" type="button">Desktop</button>
-->
   	</div>

    
	
</template>
<script>
    export default {
        mounted() {
            
        },
        props: [
            
        ],
        data: function(){

            return {
                noneActive: false,
                desktopActive: false,
                tabletActive: false,
                mobileActive: true
            };
        },
        methods: {
            viewport: function(device){
                var vm = this;
                vm.noneActive=false;
                vm.desktopActive=false;
                vm.tabletActive=false;
                vm.mobileActive=false;
                switch(device){
                    case 'none':
                        vm.noneActive=true;
                        document.getElementById('deckPreviewIframe').style.width = '100%';
                        document.getElementById('deckPreviewIframe').style.height = '100vh';
                        //document.getElementById('previewbar').style.minWidth = '100%';    

                        document.getElementById('previewArea').classList.remove('desktop');
                        document.getElementById('previewArea').classList.remove('tablet');
                        document.getElementById('previewArea').classList.remove('phone');
                        document.getElementById('previewArea').classList.add('none');

                    break;
                    case 'desktop':
                        vm.desktopActive=true;
                        document.getElementById('deckPreviewIframe').style.width = '966px';
                        document.getElementById('deckPreviewIframe').style.height = '604px';
                        //document.getElementById('previewbar').style.minWidth = '1080px';    

                        document.getElementById('previewArea').classList.remove('none');
                        document.getElementById('previewArea').classList.remove('tablet');
                        document.getElementById('previewArea').classList.remove('phone');
                        document.getElementById('previewArea').classList.add('desktop');

                    break;
                    case 'tablet':
                        vm.tabletActive=true;
                        document.getElementById('deckPreviewIframe').style.width = '705px';
                        document.getElementById('deckPreviewIframe').style.height = '1010px';
                        //document.getElementById('previewbar').style.minWidth = '700px';

                        document.getElementById('previewArea').classList.remove('none');
                        document.getElementById('previewArea').classList.remove('desktop');        
                        document.getElementById('previewArea').classList.remove('phone');
                        document.getElementById('previewArea').classList.add('tablet');            
                    break;
                    case 'mobile':
                        vm.mobileActive=true;
                        document.getElementById('deckPreviewIframe').style.width = '374px';
                        document.getElementById('deckPreviewIframe').style.height = '770px';
                        //document.getElementById('previewbar').style.minWidth = '400px';

                        document.getElementById('previewArea').classList.remove('none');
                        document.getElementById('previewArea').classList.remove('desktop');
                        document.getElementById('previewArea').classList.remove('tablet');
                        document.getElementById('previewArea').classList.add('phone');       
                    break;
                }

            }
        }
    }
</script>
